import { TythonColumnsEnum } from '../../@data/store/schema/ColumnsEnum';
import { ChartGrain } from '../../DashboardCards/ReportCard/ReportCard.types';
import { ICustomCalenderDateRange, RangeType } from '../CustomCalender/CustomCalender.types';

export interface IReportItem {
  id: string;
  name: string;
  filters: { [key: string]: string[] };
  columns: TythonColumnsEnum[];
  reportType: string;
  grain: ChartGrain;
  dateRange: ICustomCalenderDateRange;
  rangeType: RangeType;
  isSaved: boolean;
  isScheduled: boolean;
}

export interface ISavedReportItem extends IReportItem {
  reportDeliveryEmails?: string[];
  reportScheduleFrequency?: ChartGrain;
}

export interface IReportSection {
  id: string;
  name: string;
  icon?: React.ReactElement;
  items: ISavedReportItem[];
}

export const SYNDICATION_SECTION_ID = 'syndication';
export const DISTRIBUTION_SECTION_ID = 'distribution';
export const MY_REPORT_SECTION_ID = 'saved';
